
































































































import Vue from "vue";
import firebase from "@/plugins/firebase";
// eslint-disable-next-line no-unused-vars
import { User } from "@/types";

export default Vue.extend({
  metaInfo: {
    title: "Kullanıcı Kaydı"
  },
  data: () => ({
    form: {
      firstName: "",
      lastName: "",
      password: "",
      passwordConfirm: "",
      email: "",
      phone: ""
    },
    alert: false,
    message: "",
    error: false
  }),
  computed: {
    firstNameRules() {
      return [(v: any) => !!v || "Lütfen adınızı yazınız"];
    },
    lastNameRules() {
      return [(v: any) => !!v || "Lütfen soyadınızı yazınız"];
    },
    emailRules() {
      return [
        (v: any) => !!v || "Lütfen e-postanızı yazınız",
        (v: any) => /.+@.+\..+/.test(v) || "Geçersiz e-posta adresi"
      ];
    },
    phoneRules() {
      return [
        (v: string) => !!v || "Lütfen telefon numaranızı yazınız",
        (v: string) =>
          /^(05)([0-9]{2})\s?([0-9]{3})\s?([0-9]{2})\s?([0-9]{2})$/.test(v) ||
          "Geçersiz telefon numarası"
      ];
    },
    passwordRules() {
      return [
        (v: any) => !!v || "Lütfen parolanızı yazınız",
        (v: any) => v.length >= 6 || "En az 6 karakter olmalıdır"
      ];
    },
    passwordConfirmRules() {
      return [
        (v: any) => !!v || "Lütfen parolanızı onaylayınız",
        (v: any) => v.length >= 6 || "En az 6 karakter olmalıdır",
        (v: any) => v === this.form.password || "Parola onaylanmadı"
      ];
    }
  },
  methods: {
    validate() {
      const form = this.$refs.form as HTMLFormElement;
      return form.validate();
    },
    reset() {
      const form = this.$refs.form as HTMLFormElement;
      form.reset();
    },
    resetValidation() {
      const form = this.$refs.form as HTMLFormElement;
      form.resetValidation();
    },
    signup() {
      if (this.validate()) {
        // // Show message and exit without sign up.
        // this.error = true;
        // this.alert = true;
        // this.message =
        //   "UTEx şu an yeni kullanıcı kaydına kapalıdır. İlginiz için teşekkür ederiz.";

        firebase
          .auth()
          .createUserWithEmailAndPassword(this.form.email, this.form.password)
          .then(userRef => {
            if (!userRef.user) return;

            // Update user profile
            userRef.user.updateProfile({
              displayName: `${this.form.firstName} ${this.form.lastName}`
            });

            const newUser: User = {
              id: userRef.user.uid,
              firstName: this.form.firstName,
              lastName: this.form.lastName,
              displayName: `${this.form.firstName} ${this.form.lastName}`,
              email: this.form.email,
              phone: this.form.phone,
              roles: ["student"]
            };

            firebase
              .firestore()
              .collection("/profiles")
              .add({
                uid: newUser.id,
                firstName: newUser.firstName,
                lastName: newUser.lastName,
                email: newUser.email,
                phone: newUser.phone,
                roles: newUser.roles
              })
              .then(() => {
                // Send welcome email
                var sendWelcomeEmail = firebase
                  .functions()
                  .httpsCallable("email-sendWelcomeEmail");

                sendWelcomeEmail({ uid: userRef.user?.uid }).catch(err => {
                  console.error(err);
                });

                this.$store.dispatch("auth/signIn", newUser);

                this.error = false;
                this.alert = true;
                this.message =
                  "Kullanıcı kaydınız başarıyla tamamlandı. Lütfen bekleyin...";

                this.$router.push({ name: "home" });
              })
              .catch(err => {
                throw `Kullanıcı profili oluşturulamadı. ${err}`;
              });
          })
          .catch(err => {
            this.error = true;
            this.alert = true;
            this.message = this.getErrorMessage(err.code);
          });
      }
    },
    getErrorMessage(code: string) {
      var msg = "";
      switch (code) {
        case "auth/email-already-in-use":
          msg =
            "Bu e-posta adresi başka bir hesap tarafından zaten kullanılıyor.";
          break;
        case "auth/invalid-email":
          msg = "e-Posta adresi geçersiz.";
          break;
        case "auth/operation-not-allowed":
          msg = "Bu işlemi gerçekleştirmek için izniniz yok.";
          break;
        case "auth/weak-password":
          msg = "Parolanız en az 6 karakter uzunluğunda olmalıdır.";
          break;
        default:
          msg =
            "HATA! Kullanıcı kaydı tamamlanamadı. Lütfen daha sonra tekrar deneyiniz.";
      }
      return msg;
    }
  },
  mounted() {
    this.$emit("setTitle", "Kullanıcı Kaydı");
  }
});
